import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import type { ITextProps } from './ITextProps';

const tagMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  h7: 'h6',
  p1: 'p',
  p2: 'p',
  p3: 'p',
  p4: 'p',
  p5: 'p',
};

export const textVariants = cva('', {
  variants: {
    intent: {
      h1: 'md:text-5xl text-[38px] font-chromatica font-black text-retail-text-primary !leading-[120%]',
      h2: 'md:text-[40px] text-[32px] font-chromatica font-black text-retail-text-primary !leading-[120%]',
      h3: 'md:text-[32px] text-2xl font-chromatica font-black text-retail-text-primary !leading-[120%]',
      h4: 'md:text-2xl text-xl font-chromatica font-black text-retail-text-primary !leading-[120%]',
      h5: 'md:text-lg text-base font-semibold text-retail-text-primary !leading-[130%]',
      h6: 'md:text-base text-sm font-semibold text-retail-text-primary !leading-[130%]',
      h7: 'md:text-sm text-xs font-semibold text-retail-text-primary !leading-[130%]',
      p1: 'md:text-[32px] text-2xl font-chromatica font-bold text-retail-text-primary !leading-[140%]',
      p2: 'md:text-2xl text-xl font-chromatica md:font-bold font-medium text-retail-text-primary !leading-[140%]',
      p3: 'md:text-xl text-base text-retail-text-primary !leading-[130%] font-normal',
      p4: 'md:text-base text-sm text-retail-text-primary !leading-[160%] font-normal',
      p5: 'md:text-sm text-xs text-retail-text-primary !leading-[160%] font-normal',
    },
  },
});

export type TextVariantProps = VariantProps<typeof textVariants>['intent'];

const Text = forwardRef<HTMLHeadingElement, ITextProps>((props, ref) => {
  const { className, variant, ...rest } = props;

  const styles = textVariants({ intent: props.variant });

  const Element = React.createElement(tagMapping[variant], {
    className: twMerge(styles, className),
    ...rest,
    ref,
  });
  return Element;
});

Text.displayName = 'Text';

export default Text;
